'use strict';
app.controller('indexController',
    ['$scope', '$state', 'authService', 'broadcastService', '$window', '$rootScope', 'msgService', 'signalRService', 'displayService', '$ocLazyLoad',
        function ($scope, $state, authService, broadcastService, $window, $rootScope, msgService, signalRService, displayService, $ocLazyLoad)
        {
            //invoke cacheService
            broadcastService.initializeCustomKendoFunction();

            $scope.langKey = $rootScope.userSetting ? $rootScope.userSetting.langKey : 1;

            $scope.login = function ()
            {
                if ($scope.loginData.userName != "" && $scope.loginData.password != "")
                {
                    authService.logOut();
                    $scope.message = broadcastService.getMsg(401).MsgBody;//'Authenticating...';
                    $scope.isLoggingIn = true;
                    signalRService.keepAlive(false);
                    authService.login($scope.loginData.clientID, $scope.loginData.userName, $scope.loginData.password).then(() =>
                    {
                        signalRService.checkAlive().then(() =>
                        {
                            signalRService.startMainSignalR().then(() => Promise.resolve(true), () => Promise.resolve(false)).then(() =>
                            {
                                signalRService.keepAlive(true);
                                displayService.refresh().then(() => Promise.resolve(true), () => Promise.resolve(false)).then(() =>
                                {
                                    broadcastService.broadcast("closeWinLogin", true);
                                    $scope.loginData = { userName: "", password: "" };
                                    $rootScope.IdleRestart();
                                    $rootScope.isShowLogin = false;
                                    $rootScope.sendOnce = false;
                                    $scope.message = '';
                                    $scope.isLoggingIn = false;
                                    $rootScope.$emit("CallReloginMethod", {});
                                    signalRService.postScreenSize();
                                    signalRService.postNetSpeed();
                                });
                            });
                        }, () => { $scope.message = "Connection to server failed. Please try again later."; $scope.isLoggingIn = false; });
                    }, (err) =>
                    {
                        if (err?.error === "Request PIN")
                        {
                            $scope.message = "Two-Factor Authentication PIN is required. You will be redirected to login page shortly."; //$scope.isLoggingIn = false;
                            setTimeout(() => $scope.logOut(true), 3000);
                        }
                        else
                        {
                            $scope.message = err.error_description; $scope.isLoggingIn = false;
                        }
                    });
                }
            };

            $scope.style = [];

            $scope.loginData = {
                userName: "",
                password: ""
            };

            $scope.showhideDropDownMenu = function ()
            {
                if ($scope.style.length == 0)
                {
                    $scope.style = { 'display': 'block' };
                }
                else
                {
                    $scope.style = [];
                }
            };

            $scope.hideDropDownMenu = function ()
            {
                $scope.style = [];
            }

            $scope.showAll = true;

            $scope.$window = $window;

            $rootScope.$on("SignalRLogout", function ()
            {
                $scope.logOut(true);
            });

            $scope.logOut = function (reload)
            {
                $window.document.title = $rootScope.appName;
                $rootScope.isShowLogin = false;
                //$scope.style = [];
                $scope.loginData = { userName: "", password: "" };
                $scope.message = '';
                $scope.isLoggingIn = false;

                //wait regardless of success or failure
                signalRService.keepAlive(false);
                signalRService.stopMainSignalR().then(function ()
                {
                    signalRService.stopSignalR("workflow");
                    signalRService.stopSignalR("procurement");

                    $scope.showhideDropDownMenu();
                    $state.go('login');
                    authService.lastSession = null;
                    authService.logOut();

                    if (reload === true)
                    {
                        window.onbeforeunload = null;
                        window.location.href = window.location.origin;
                    }
                }, function ()
                {
                    signalRService.stopSignalR("workflow");
                    signalRService.stopSignalR("procurement");

                    $scope.showhideDropDownMenu();
                    $state.go('login');
                    authService.lastSession = null;
                    authService.logOut();

                    if (reload === true)
                    {
                        window.onbeforeunload = null;
                        window.location.href = window.location.origin;
                    }
                });
            }

            if (!authService.authentication.isAuth)
            {
                $state.go('login');
            }

            $scope.msgService = msgService;

            //not 100% works....kinda useless, but better than none
            if (typeof window.onunload === "function")
            {
                let JQueryUnload = window.onunload;
                window.onunload = function (e)
                {
                    JQueryUnload(e);

                    console.log("%cUnload triggered!", 'background:blue;color:#fff');
                    signalRService.keepAlive(false);
                    signalRService.stopMainSignalR();
                    signalRService.stopSignalR("workflow");
                    signalRService.stopSignalR("procurement");
                }
            }
            else
            {
                window.onunload = function (e)
                {
                    console.log("%cUnload triggered!", 'background:blue;color:#fff');
                    signalRService.keepAlive(false);
                    signalRService.stopMainSignalR();
                    signalRService.stopSignalR("workflow");
                    signalRService.stopSignalR("procurement");
                }
            }

            window.onbeforeunload = null;

            window.onerror = function (message, source, lineno, colno, error)
            {
                broadcastService.logGeneralJsError(message, source, lineno, colno, error);
            };

            // Make sure we call this only when `document.readyState === "complete"`.
            // It's UI init function has bug which caused it to never fire if readyState was "interactive" when offline.min.js is loaded.
            function loadOfflineJs()
            {
                // We cannot do `window.Offline.options = {...}` as stated in the documentation because it would be too late
                // to set the configuration in `$ocLazyLoad.load(..).then()`. (`window.Offline` will only available after offline.min.js is loaded.
                //
                // One way to verify if the configuration work for us, is to make sure initiator of Quarto requests ARE NOT offline.min.js.
                //
                // Initiator should only be offline.min.js when the `options.requests` == true.
                // `options.interceptRequests` == true would never modify the initiator of requests.
                window.Offline = { options: { requests: false, interceptRequests: true, checks: { xhr: { url: '/connection-test' } } } };
                $ocLazyLoad.load({
                    name: "offline",
                    files: ['/scripts/offline.min.js', '/content/css/offline-language-english.css', '/content/css/offline-theme-chrome.css']
                }).then(() =>
                {
                    Offline.on("up", () =>
                    {
                        $scope.$apply(() =>
                        {
                            $rootScope.$broadcast("refreshDisplayInfo", {});  // reload dashboards
                        });
                    });
                });
            }

            $(window).on("load", () =>
            {
                if (document.readyState !== "complete")
                {
                    console.error(`document loaded but \`document.readyState\` is not "complete". It is "${document.readyState}" instead.`)
                } else
                {
                    loadOfflineJs();
                }
            })
        }]);
